import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, CustomInput } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import style from "./style.module.scss";
import * as UI from "../../Authorizations/UI";
import { SubTitle, ProcessContext } from "./Processes";
import { LoadingMessage } from "../Order/Precheck/Precheck";
import { Mode, Type as OrderType } from "../../../utils";
import { CircularProgress, IO, Order } from "../..";
import { FormattedDate, FormattedTime } from "react-intl";
import { localDateTime } from "../../../utils/Helper";
import { AuthorizationList } from "../..";

const trimAll = (text) => text.replace(/"\s+|\s+"/g, '"');

const Authorization = ({ authorization, open,manager, toggle, services, username, role }) => {
  if (authorization == null) return null;

  function compareStringsCaseInsensitive(str1, str2) {
    return str1.localeCompare(str2, undefined, { sensitivity: "accent" }) === 0;
  }

  const [processProps, setProcessProps] = useState(false);
  const [responsing, setResponsing] = useState({});
  const [readonly, setReadonly] = useState(
    (authorization.processedBy !== "" ||
      !compareStringsCaseInsensitive(authorization.role, role) ||
      compareStringsCaseInsensitive(authorization.requestedBy, username)) &&
    !(compareStringsCaseInsensitive(authorization.role, "Manager") && manager)
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [modalAuthListOpen, setModalAuthListOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [firstDeposit, setFirstDeposit] = useState(false);

  const handleOpenModal = () => setModalOpen((o) => !o);
  const [notesLoading, setNotesLoading] = useState(true);

  const handleOpenModalAuthList = () => {
    setModalAuthListOpen((o) => !o);
  };

  useEffect(() => {
    if (
      authorization.process === "Order" ||
      authorization.process === "Deposit" ||
      authorization.process === "Withdraw" ||
      authorization.process === "Transfer" ||
      authorization.process === "InvoiceRequest"||
       authorization.process === "CounterParty"
    ) {
      setNotesLoading(() => true);
      setProcessProps({ loading: true });
      services.getProcessContext({ id: authorization.id }).then((res) => {
        const properties = JSON.parse(res.propertiesAsJson);
        if (authorization.process === "Order") {
          properties.order = JSON.parse(trimAll(properties.Order));
        } else {
           if (properties.IO)
             properties.io = JSON.parse(properties.IO);
        }
        setNotes((prevNotes) => {
          if (!prevNotes || prevNotes.trim() === "" || prevNotes === authorization.notes) {
            return authorization.notes;
          }
          return prevNotes;
        });
        setNotesLoading(() => false);
        setProcessProps(properties);
      });
    }
  }, [authorization.id, authorization.process, services]);

  const processed = authorization.processedBy != "";

    useEffect(() => {
    if (authorization.isFirstDeposit) {
      setFirstDeposit(true);
    }
  }, [authorization.isFirstDeposit]);

  const response = (accepted) => {
    let canContinue = true;
    if (authorization.hasPendingRelatedAuthorizations) {
      canContinue = false;
      if (
        window.confirm(
          `This authorization has pending related authorizations, are you sure you want to ${
            accepted ? "authorize" : "reject"
          } it?`
        )
      ) {
        canContinue = true;
      }
    }
    if (canContinue) {
      setResponsing({ accepted, rejected: !accepted });

      services
        .responseAuth({
          id: authorization.id,
          accepted,
          "firstDeposit": firstDeposit,
          notes,
        })
        .then((r) => {
          clearState();
          toggle();
        });
    }
  };

  const clearState = () => {
    setResponsing({});
    setReadonly(false);
  };

  const handleGetAuthorizations = (...props) => {
    return services.getAuthorizations(...props).then((response) => {
      response.authorizations = response.authorizations.filter((auth) => auth.id !== authorization.id);
      return response;
    });
  };

  return (
    <React.Fragment>
      <Modal isOpen={open} className={style.modal}>
        <ModalHeader toggle={toggle}>
          Authorization
          {authorization.processedBy == "" &&
            authorization.requestedBy != username &&
            processProps &&
            !processProps.loading && <SubTitle process={authorization.process} props={processProps} />}
        </ModalHeader>
        <ModalBody className={style.body}>
          <div className={style.box}>
            <div className={style.header}>
              <Process process={authorization.process} />

              {
                <div>
                  <FormattedDate value={localDateTime(authorization.dateTime)} />{" "}
                  <FormattedTime value={localDateTime(authorization.dateTime)} hour12={false} />
                </div>
              }
            </div>

             {
                authorization.process === "Deposit" ? (
                   <div>
                    <CustomInput
                      label="puntual deposit"
                      type="checkbox"
                      id={`cbox-firstDeposit`}
                      checked={firstDeposit}
                      onChange={(v) =>
                        setFirstDeposit(!firstDeposit)
                      }
                    />
                  </div> 
                ) : null
              }
              {
                authorization.process === "Withdraw" ? (
                  <div>
                    <CustomInput
                      label="puntual withdraw"
                      type="checkbox"
                      id={`cbox-firstWithdraw`}
                      checked={firstDeposit}
                      onChange={(v) =>
                        setFirstDeposit(!firstDeposit)
                      }
                    />
                  </div> 
                ) : null
              }

            {/* Now can view process from footer button */}
            {/* {processProps &&
              (processProps.loading ? (
                <LoadingMessage
                  style={{ padding: 15 }}
                  text="Loading process detail"
                />
              ) : (
                <ProcessContext
                  process={authorization.process}
                  props={processProps}
                />
              ))} */}

            <div className={style.detail}>
              <h6 className="pt-2">{authorization.title}</h6>
              <p className="pt-2">{authorization.text}</p>
              {authorization.description !== "" &&
                (authorization.description.includes("\\r\\n") ? (
                  authorization.description.split("\\r\\n").map((name) => {
                    return <div className="pt-2">{name}</div>;
                  })
                ) : (
                  <p className="pt-2">{authorization.description}</p>
                ))}
              <hr />

              <div className={style.flex}>
                <span>
                  <label className="text-muted">Authorization Role</label>
                  <span>{authorization.role}</span>
                </span>
                <span>
                  <UI.Status status={authorization.status} />
                </span>
              </div>

              <hr />

              <div className={style.flex}>
                <span>
                  <label className="text-muted">Requested by</label>
                  <span>{authorization.requestedBy}</span>
                </span>
                <span>
                  <label className="text-muted">Processed by</label>
                  <span>{processed ? authorization.processedBy : "-"}</span>
                </span>
                <span>
                  <label className="text-muted">Processed at</label>
                  {processed ? (
                    <React.Fragment>
                      <FormattedDate value={localDateTime(authorization.processedAt)} />{" "}
                      <FormattedTime value={localDateTime(authorization.processedAt)} hour12={false} />
                    </React.Fragment>
                  ) : (
                    "-"
                  )}
                </span>
              </div>
            </div>
            <hr />
            <div>
              {notesLoading ? (
                <CircularProgress />
              ) : (
                <span>
                  <label className="text-muted">Notes</label>
                  <Input
                    type="textarea"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    name="text"
                    id="exampleText"
                  />
                </span>
              )}
            </div>
          </div>
          {authorization.hasRelatedAuthorizations && (
            <div className={style.box}>
              <Button
                color="primary"
                disabled={responsing.accepted || responsing.rejected || !processProps || processProps.loading}
                onClick={handleOpenModalAuthList}
              >
                {`Show related authorizations`}
              </Button>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            disabled={responsing.accepted || responsing.rejected}
            onClick={() => toggle()}
          >
            Close
          </Button>
          {(authorization.process === "Order" ||
            authorization.process === "Deposit" ||
            authorization.process === "Withdraw") && (
            <Button
              color="primary"
              disabled={responsing.accepted || responsing.rejected || !processProps || processProps.loading}
              onClick={handleOpenModal}
            >
              {`Show ${authorization.process}`}
            </Button>
          )}
          {readonly == false && (
            <React.Fragment>
              <LaddaButton
                disabled={responsing.accepted}
                className="btn btn-ladda btn-danger"
                loading={responsing.rejected}
                onClick={() => response(false)}
                data-style={EXPAND_RIGHT}
              >
                <i className="icon-close icons" />
                &nbsp;
                {"Reject"}
              </LaddaButton>
              <LaddaButton
                disabled={responsing.rejected}
                className="btn btn-ladda btn-success"
                loading={responsing.accepted}
                onClick={() => response(true)}
                data-style={EXPAND_RIGHT}
              >
                <i className="icon-check icons" />
                &nbsp;
                {"Authorize"}
              </LaddaButton>
            </React.Fragment>
          )}
        </ModalFooter>
      </Modal>
      {modalOpen && authorization.process === "Order" && (
        <Order
          userType="Advisor"
          open={modalOpen}
          mode={Mode.READONLY}
          type={OrderType.DEFAULT}
          order={processProps.order}
          toggle={handleOpenModal}
          imageSource={"img/logo-symbol.png"}
          platformRole={role}
          {...services.order}
        />
      )}
      {modalOpen && (authorization.process === "Deposit" || authorization.process === "Withdraw") && (
        <IO
          open={modalOpen}
          io={processProps.io}
          mode={Mode.READONLY}
          toggle={handleOpenModal}
          services={{
            ...services.io,
          }}
        />
      )}
      {modalAuthListOpen && (
        <AuthorizationList
          open={modalAuthListOpen}
          process={authorization.process}
          processId={authorization.process === "Order" ? processProps.order.OrderId : processProps.io.Id}
          toggle={handleOpenModalAuthList}
          services={{
            getAuthorizations: handleGetAuthorizations,
          }}
        />
      )}
    </React.Fragment>
  );
};

const Process = ({ process }) => <div className={style.process}>{process}</div>;

export default Authorization;
